
import Vue from "vue";
import { baseVueController } from "./baseVueController";
import { ajax, idb, lstorage, ui } from "./util";
import * as es6promise from "es6-promise";
import { dialogUtil } from "./util/dialog";
import { orderInfo } from "./entity/idb/orderInfo";
import { editInfo } from "./entity/idb/editInfo";
import { hagakiMasterInfo, masterInfo } from "./entity/idb/masterInfo";
import { constDialogMessage } from "./util/const";
import { common } from "./util/common";
import { MultiTab } from "./util/multitab";
import { util } from ".";
import { Logger } from "./util/logger";
import { SSO } from "./util/sso";

// gigya
declare var gigya: any;

//------------------------------------------------------------------------------
// クラス
//------------------------------------------------------------------------------
/**
 * はがき種/枚数選択画面コントローラクラス
 * */
export class hagakiSelectController extends baseVueController {

	//--------------------------------------------------------------------------
	// 定数
	//--------------------------------------------------------------------------
	private readonly ELEMENT_NAME: string = "#hagakiSelectController";

	// 印刷タイプ
	private readonly INSATSU: string = "1";
	private readonly GINEN: string = "2";

	// idb関連
	private readonly EDIT_INFO_STORENAME: string = "editInfo";
	private readonly OREDER_INFO_STORENAME: string = "orderInfo";
	private readonly MASTER_INFO_STORENAME: string = "masterInfo";

	// 画面URL
	private readonly ViewURL_Preview: string = "Preview"; // 戻る
	private readonly ViewURL_AtenaSelect: string = "AtenaSelect"; // 次へ

	// 保存期限日数
	private readonly SAVE_LIMIT = 90;

	// 戻る/次へボタン文言
	private readonly PC_GO_CART = "変更しないで戻る";
	private readonly PC_GO_ATENA_SELECT = "変更する";
	private readonly SP_GO_CART = "戻る";
	private readonly SP_GO_ATENA_SELECT = "確定";

	private readonly NORMAL_PREV = "戻る";
	private readonly NORMAL_ATENA = "次へ";

	//--------------------------------------------------------------------------
	// 変数
	//--------------------------------------------------------------------------
	// idb
	private _editInfo: editInfo;
	private _orderInfo: orderInfo;
	private _masterInfo: masterInfo;

	/**
	 * ロゴ１ URL
	 */
	private _logo1Url: string;
	/**
	 * ロゴ２ URL
	 */
	private _logo2Url: string;

	// 認証トークン
	private _token: string;

	//--------------------------------------------------------------------------
	// プロパティ
	//--------------------------------------------------------------------------

	//--------------------------------------------------------------------------
	// コンストラクタ
	//--------------------------------------------------------------------------

	//--------------------------------------------------------------------------
	// メソッド
	//--------------------------------------------------------------------------
	/**
	 * 初期化メソッド
	 * */
	public init(): void {

		console.log("hagakiSelect start");

		// 複数タブ禁止
		const multiTabCheck = () => {
			MultiTab.forbiddenMultiTab(() => {
				dialogUtil.createErrorDialog(constDialogMessage.WARNING_MULTITAB_FORBIDDEN
					, () => { }
					, null
					, true
				);
			})
		}
		setInterval(multiTabCheck, MultiTab.INTERVAL);

		// エラー時のボタン遷移先
		this.SetErrorPageInfo();

		// vueオブジェクト生成
		this._vue = new Vue({
			el: this.ELEMENT_NAME,
			data: {
				// 保管期限
				saveLimit: "YYYY年MM月DD日",
				// ハガキ種選択コンボ
				hagakiTypes: [],
				// 選択されているハガキ種
				hagakiTypeSelected: {},
				// 入力された注文枚数
				inputHagakiQuantity: "",
				// 注文最小数
				orderMin: 0,
				// 注文最大数
				orderMax: 0,
				// 戻るボタンの表示制御
				//isPrevShow: true,
				// プルダウン表示用(SPのみ)
				typeName: "",
				// 読み込み完了フラグ
				loadComplete: false,
				// ヘッダーメニュー
				Header: {
					Logo1Url: this._logo1Url,
					Logo2Url: this._logo2Url,
				},
				// ボタン文言
				PrevButtonMessage: "",
				NextButtonMessage: "",
				// 表示制御
				Show: {
					// 操作方法の表示(空の場合は表示しない)
					OperationInfo: this._retailerConfig.operationInfo.hagakiSelect ? true : false,

					// 投函代行関連文言表示
					IsShowSupplement: (this._retailerConfig.id === "0" || this._retailerConfig.id === "36") ? true : false,
				}

			},
			methods: {
				// 戻るボタン
				btnClickReturnFlow: (event: JQueryEventObject) => {
					this.btnClickReturnFlow(event);
				},
				// 進むボタン
				btnClickNextFlow: (event: JQueryEventObject) => {
					this.btnClickNextFlow(event);
				},
				// 一時保存
				btnClickSave: (event: JQueryEventObject) => {
					this.btnClickSave(event);
				},
				// 操作方法
				btnClickOperationHelp: (event: JQueryEventObject) => {
					this.btnClickOperationHelp(event);
				},
				// ハガキ枚数入力 -> 次へボタン制御
				hagakiNumChange: (event: JQueryEventObject) => {
					this.hagakiNumChange(event);
				},
				// ヘッダー
				btnClickReturnTop: (event: JQueryEventObject) => {
					this.btnClickReturnTop(event);
				},
				btnClickFaq: (event: JQueryEventObject) => {
					this.btnClickFaq(event);
				},
				btnClickOrderHistory: (event: JQueryEventObject) => {
					this.btnClickOrderHistory(event);
				}
			}, mounted: () => {

				// リテーラ別のチャットボット制御
				var divChatBot = document.getElementById("chava-root") as HTMLDivElement;
				if (divChatBot) {
					divChatBot.style.display = this._retailerConfig.id == "0" ? "block" : "none";
				}

				// DOM読み込み後に実行する。
				this.doOnload();
			}
		});

		// リテーラ別の初期処理
		this.initRetailer();
	}

	/**
	 * リテーラ別の初期化処理
	 * */
	public initRetailer(): void {
		if (this.getIsAddOrder()) {

			// 追加注文時
			this._vue.$data.orderMin = this._retailerConfig.poscaSettings.addOrderNum.addOrderMin
			this._vue.$data.orderMax = this._retailerConfig.poscaSettings.addOrderNum.addOrderMax


		} else {

			// 通常注文時
			this._vue.$data.orderMin = this._retailerConfig.poscaSettings.orderNum.orderMin
			this._vue.$data.orderMax = this._retailerConfig.poscaSettings.orderNum.orderMax

		}

		// リテーラロゴURL設定
		this._vue.$data.Header.Logo1Url = this._retailerConfig.logo1;
		this._vue.$data.Header.Logo2Url = this._retailerConfig.logo2;
	}

	/**
	 * 画面初期化
	 * */
	private async doOnload(): es6promise.Promise<void> {

		// ローディングダイアログ開始
		dialogUtil.showLoading();

		// gigya イベントリスナー登録
		if (this._retailerConfig.id == "0") {
			gigya.socialize.addEventHandlers({
				onLogin: common.onLoginHandlerWithSave
				//onHide: common.onHideHandler
			});
		}
		// tokenを画面から確保
		this.getAuthToken();

		// SSO
		Logger.log("SSO開始");
		await SSO.DoSSO(this._token, this._retailerConfig.id);

		// 「戻るボタンの文言」の処理が実行されるため、ダミー関数を呼ばせています。
		await this.dummyFucn();

		// 途中復帰か？
		if (this.getIsReturn()) {

			await SSO.WaitSSO();
			await common.InitReturn(this._token);

			// 戻る/次へボタンの制御
			if (this.getIsPC()) {

				this._vue.$data.PrevButtonMessage = this.PC_GO_CART;
				this._vue.$data.NextButtonMessage = this.PC_GO_ATENA_SELECT;

			} else {

				this._vue.$data.PrevButtonMessage = this.SP_GO_CART;
				this._vue.$data.NextButtonMessage = this.SP_GO_ATENA_SELECT;

			}

		} else {
			this._vue.$data.PrevButtonMessage = this.NORMAL_PREV;
			this._vue.$data.NextButtonMessage = this.NORMAL_ATENA;
		}

		// idbからのデータ読み込み
		this.loadIDB().then(() => {

			// 画面初期化
			this.initDisp().then(() => {
				// 選択状態復帰
				this.returnOrder();

			}).catch(() => {
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_SYSTEM, dialogUtil.closeErrorDialog);
				return es6promise.Promise.reject;

			}).finally(() => {

				this._vue.$data.loadComplete = true;

				// "contents"要素の子要素の非表示を解除
				$("#contents").removeClass("visHidden");

				// フォーカスセット
				$("#countSelect").focus();

				// ダイアログ閉じ
				dialogUtil.closeLoading();

			});


		}).catch((msg) => {
			dialogUtil.createErrorDialog(msg, dialogUtil.closeErrorDialog);
			return es6promise.Promise.reject;
		});

	}

	/**
	 * 画面の初期表示
	 * */
	private async initDisp(): es6promise.Promise<any> {

		return new Promise((res, rej) => {

			try {
				// seq順に並び替え
				this._masterInfo.hagakiMasterInfo.sort((a, b) => {
					return a.seq - b.seq;
				})

				// プルダウン用にバインド
				this._vue.$data.hagakiTypes = this._masterInfo.hagakiMasterInfo;

				// 初期選択状態の値設定
				this._vue.$data.hagakiTypeSelected = this._masterInfo.hagakiMasterInfo[0];

				// 保存日のお知らせ
				this.getSaveLimit(this.SAVE_LIMIT);

				res("");
			} catch (e) {
				rej(e);
			}
		})
	}

	private async dummyFucn(): es6promise.Promise<any> {
		return "";
	}

	/**
	 * 注文情報からの状態復帰
	 * */
	private returnOrder(): void {

		// 注文情報が空の場合(=初めてこの画面に来た)は、何もしない。
		if (this._orderInfo == null) return;
		if (Object.keys(this._orderInfo).length == 0) return;

		const orderSelected = this._orderInfo.postcardType;
		const item = this._masterInfo.hagakiMasterInfo.filter(function (x) {
			return x.id == orderSelected
		})[0];

		if (!item) return;

		if (this._editInfo.printType == this.INSATSU) {
			if (item.id == "8") {
				// 印刷でディズニータイプは無効
				return;
			}
		}

		// 選択状態アイテムの設定
		this._vue.$data.hagakiTypeSelected = item;

		// 枚数の更新
		this._vue.$data.inputHagakiQuantity = this._orderInfo.num;

		// ボタン有効化
		this.enableNextButton();

	}

	/**
	 * 保存期限を計算する。
	 * */
	private getSaveLimit(addDay: number): void {

		const date = new Date();
		date.setDate(date.getDate() + addDay);

		const yyyy = date.getFullYear();
		const MM = ("0" + (date.getMonth() + 1)).slice(-2);
		const dd = ("0" + date.getDate()).slice(-2);

		this._vue.$data.saveLimit = yyyy + "年" + MM + "月" + dd + "日";
	}

	/**
	 * indexedDBからの読み込み
	 * @param event
	 */
	private async loadIDB(): es6promise.Promise<any> {

		// 編集情報マスタから読み込み
		this._editInfo = lstorage.get<editInfo>(lstorage.KEY_EDIT, true);
		if (!this._editInfo) {
			// 読み込み失敗
			return es6promise.Promise.reject<string>(constDialogMessage.ERROR_LOCAL_DB_READ);
		}

		// マスタからハガキ種読み込み
		const getMaster: masterInfo = lstorage.get<masterInfo>(lstorage.KEY_MASTER, true);
		if (getMaster) {
			this._masterInfo = new masterInfo();
			if (this._editInfo.printType == this.GINEN) {
				// ディズニーは銀塩のみ。
				this._masterInfo.hagakiMasterInfo = getMaster.hagakiMasterInfo.filter(x => x.id != "7"); // 1枚無料ハガキは表示させない。
			} else {
				// 印刷タイプではディズニーハガキは許可しない。
				this._masterInfo.hagakiMasterInfo = getMaster.hagakiMasterInfo.filter(x => {
					if (!(x.id == "7" || x.id == "8")) {
						return true;
					}
				
				});
			}
		}
		else {
			// 読み込み失敗
			return es6promise.Promise.reject<string>(constDialogMessage.ERROR_LOCAL_DB_READ);
		}

		// 注文情報からの取得。(途中保存の場合は前回入力した状態から復帰する。)
		this._orderInfo = lstorage.get<orderInfo>(lstorage.KEY_ORDER, true);
		if (!this._orderInfo) {
			// 空の場合はorderInfo新規作成
			this._orderInfo = new orderInfo();
			if (!lstorage.set(lstorage.KEY_ORDER, this._orderInfo)) {
				// 新規作成失敗
				return es6promise.Promise.reject<string>(constDialogMessage.ERROR_LOCAL_DB_WRITE);
			}
		}

	}

	/**
	 * 入力された状態をidbに保存する。
	 * */
	private saveOrderInfo(hagakiNum: number, idx: string): es6promise.Promise<any> {

		return new Promise((res, rej) => {

			// 更新
			this._orderInfo.num = hagakiNum;
			this._orderInfo.postcardType = idx;

			if (lstorage.set(lstorage.KEY_ORDER, this._orderInfo)) {
				res("");
			}
			else {
				rej();
			}
		});
	}

	/**
	 * 入力エリアの半角チェックを行います。
	 * */
	private validateNum(input: string): boolean {
		const pattern = /^[-]?([1-9]\d*|0)(\.\d+)?$/;
		return pattern.test(input);
	}

	/**
	 * 入力エリアの数値チェックを行います。
	 * */
	private validateRange(input: string): boolean {
		const n = parseInt(input);
		const min = this._vue.$data.orderMin;
		const max = this._vue.$data.orderMax;
		if (n >= min && max >= n) {
			return true;
		}
		return false;
	}

	/**
	 * 次へボタンの有効
	 * */
	private enableNextButton(): void {
		$("#nextBtnDiv").removeClass("is-disabled");
	}

	/**
	 * 次へボタンの無効
	 * */
	private disableNextButton(): void {
		$("#nextBtnDiv").addClass("is-disabled");
	}

	/**
	 * 認証トークン取得
	 */
	private getAuthToken(): void {

		// hiddenから認証トークン取得＆クリア
		this._token = $("#Token").val();
		//$("#Token").val("");

	}

	//--------------------------------------------------------------------------
	// イベント
	//--------------------------------------------------------------------------
	/**
	* 前画面遷移ボタン押下メソッド
	* */
	public btnClickReturnFlow(event: JQueryEventObject): void {

		if (this.getIsReturn()) {

			// カートからgetで遷移したときはカートに返す。
			// ローディング開始
			dialogUtil.showLoading();

			common.SaveDataForceForCart(this._token);

		} else {

			// 通常系はプレビューに戻る。
			const form = document.createElement('form');
			form.action = this.ViewURL_Preview;
			form.method = 'POST';
			$('body').append(form);

			form.submit();
			//history.back();
		}

	}

	/**
	 * 次画面遷移ボタン押下メソッド
	 * */
	public btnClickNextFlow(event: JQueryEventObject): void {

		// 半角チェック
		const inputNum = this._vue.$data.inputHagakiQuantity;
		if (!this.validateNum(inputNum)) {
			dialogUtil.createErrorDialog(constDialogMessage.ERROR_HAGAKINUM_VALIDATION_CHARACTER, dialogUtil.closeErrorDialog, dialogUtil.DialogType.None);
			return;
		}

		// 枚数チェック
		if (!this.validateRange(inputNum)) {
			dialogUtil.createErrorDialog("枚数は" + this._vue.$data.orderMin + "枚～" + this._vue.$data.orderMax + "枚の範囲で入力してください。"
				, dialogUtil.closeErrorDialog, dialogUtil.DialogType.None);
			return;
		}

		// ローディング開始
		dialogUtil.showLoading();

		// indexedDBのパラメータを更新したのち、画面遷移
		const hagakiType = this._vue.$data.hagakiTypeSelected as hagakiMasterInfo
		this.saveOrderInfo(parseInt(inputNum), hagakiType.id).then(() => {

			if (this.getAtenaStop()) {
				const that = this;
				const okFunc = function () {
					// 宛名受付停止期間内はカートへ直接投下
					dialogUtil.closeYesNoDialog();
					common.SaveDataForceForCart(that._token);
				}
				const ngFunc = function () {
					dialogUtil.closeYesNoDialog();
				}
				dialogUtil.createYesNoDialog(constDialogMessage.INFO_ATENA_ORDER_STOP, okFunc, ngFunc,"OK","キャンセル");

			}else if (this._retailerConfig.poscaSettings.allowAtena) {
				// 宛名印刷OKリテーラ
				// 通常注文であれば宛名選択画面へ。
				const form = document.createElement('form');
				form.action = this.ViewURL_AtenaSelect;
				form.method = 'POST';
				$('body').append(form);

				form.submit();
			} else {
				// 宛名印刷不可リテーラ→カートへ→強制保存
				common.SaveDataForceForCart(this._token);
			}

		}).catch((e) => {

			// idb更新失敗
			dialogUtil.createErrorDialog(constDialogMessage.ERROR_LOCAL_DB_WRITE, dialogUtil.closeErrorDialog);

		}).finally(() => {

			dialogUtil.closeLoading();

		});

	}

	/**
	 * デザインとリテーラと仕上げから宛名受付期間内か判定します。
	 * */
	private getAtenaStop(): boolean {

		const isInsatsu = this._editInfo.printType == this.INSATSU ? true : false;
		if (isInsatsu) {

			// Hiddenから受付停止中かどうかチェック
			const v = $('#atenaOrderStopInsatsu').val().toLowerCase();
			if (v == "true") {
				return true;
			} else {
				return false;
			}
				
		} else {
			const v = $('#atenaOrderStopGinen').val().toLowerCase();
			if (v == "true") {
				return true;
			} else {
				return false;
			}

		}
	}

	/**
	 * ハガキ入力枚数チェックイベント
	 * */
	private hagakiNumChange(event: JQueryEventObject): void {

		if (this._vue.$data.inputHagakiQuantity.length > 0) {
			
			if (this._vue.$data.inputHagakiQuantity > this._vue.$data.orderMax) {
				// 上限を超えての入力をしたとき
				dialogUtil.createErrorDialog("枚数は" + this._vue.$data.orderMin + "枚～" + this._vue.$data.orderMax + "枚の範囲で入力してください。", () => {
					this._vue.$data.inputHagakiQuantity = this._vue.$data.inputHagakiQuantity.substr(0, 3);
					dialogUtil.closeErrorDialog();
					return;
				});
				return;
			} else if (this._vue.$data.inputHagakiQuantity.length > 3) {
				// ３桁を超えて入力したとき
				dialogUtil.createErrorDialog("入力可能な文字数は３桁までです。", () => {
					this._vue.$data.inputHagakiQuantity = this._vue.$data.inputHagakiQuantity.substr(0, 3);
					dialogUtil.closeErrorDialog();
					return;
				});
				return;
            }
			// 何かしらの入力。
			this.enableNextButton();
		} else {
			// 何も入っていない。
			this.disableNextButton();
		}
	}

	/**
	 * 一時保存ボタン押下メソッド
	 * */
	public btnClickSave(event: JQueryEventObject): void {

		// 半角チェック
		const inputNum = this._vue.$data.inputHagakiQuantity;
		if (!this.validateNum(inputNum)) {
			dialogUtil.createErrorDialog(constDialogMessage.ERROR_HAGAKINUM_VALIDATION_CHARACTER, dialogUtil.closeErrorDialog, dialogUtil.DialogType.None);
			return;
		}

		// 枚数チェック
		if (!this.validateRange(inputNum)) {
			dialogUtil.createErrorDialog("枚数は" + this._vue.$data.orderMin + "枚～" + this._vue.$data.orderMax + "枚の範囲で入力してください。"
				, dialogUtil.closeErrorDialog, dialogUtil.DialogType.None);
			return;
		}

		// ハガキ種
		const postcardType = this._vue.$data.hagakiTypeSelected.id;

		// idb更新
		this.saveOrderInfo(inputNum, postcardType).then(() => {
			// 最新のidbで保存する。
			const editInfo: editInfo = lstorage.get<editInfo>(lstorage.KEY_EDIT, false);
			const orderInfo: orderInfo = lstorage.get<orderInfo>(lstorage.KEY_ORDER, false);
			common.SaveData(this._token, editInfo, orderInfo);
		});
	}

	/**
	 * 操作方法ボタン押下メソッド
	 * */
	private btnClickOperationHelp(event: JQueryEventObject): void {

		ui.windowOpen(this._retailerConfig.operationInfo.hagakiSelect, "", null, null);

	}

}


